export default {
  Title   : 'Πως ήταν η εμπειρία σου;',
  Subtitle: 'Η αξιολόγηση σου μας βοηθά να βελτιωθούμε',
  Button  : 'Rate Now',
  Comments: 'Σχόλιο αξιολόγησης',
  Reviews : 'Αξιολογήσεις',
  Success : 'Ευχαριστούμε για την αξιολόγηση σου!'
}
